<template>
  
  <div class="product-content">
    <el-dialog title="升级申请审核" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">昵称：</span>
              {{ detail.user.nickName }}
            </div>
          </el-col>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">手机：</span>
              {{ detail.user.mobile }}
            </div>
          </el-col>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">当前等级：</span>
                {{ detail.oldgrade?detail.oldgrade.name:'' }}
            </div>
          </el-col>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">拟申请等级：</span>
                {{ detail.grade?detail.grade.name:'' }}
            </div>
          </el-col>
          <el-col :span="10">
            <div class="pb16">
              <span class="gray9">申请时间：</span>
              {{ detail.create_time }}
            </div>
          </el-col>

        </el-row>
      </div>
    
      <div class="common-form">审核操作</div>
      <el-form :model="detail" >
        <el-form-item label="审核状态" :label-width="formLabelWidth">
          <div>
            <el-radio-group v-model="detail.order_status">
              <!-- <el-radio  :label="10">待审核</el-radio> -->
              <el-radio  :label="30">审核通过</el-radio>
              <el-radio  :label="20">拒绝</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
          <el-form-item label="原因"  v-if="detail.order_status==20" :label-width="formLabelWidth"><el-input v-model="detail.reject_reason" autocomplete="off"></el-input></el-form-item>
          <!-- <div v-if="detail.order_status==20">
             <el-form-item label="审核状态" :label-width="formLabelWidth">
            <div >
              <el-radio-group v-model="detail.reject_status">
                <el-radio  :label="10">无操作</el-radio>
                <el-radio  :label="20">待退款</el-radio>
                <el-radio  :label="30">已退款</el-radio>
              </el-radio-group>
            </div>
            </el-form-item>
          </div> -->
      </el-form>
      <div slot="footer"  class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="editApplyStatus">确 定</el-button>
      </div>
      
    </el-dialog>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';
export default {
  data() {
    return {
      detail:{

      },
      certification:{
        name:'',
        certificate_no:'',
        front_idcard:'',
        back_idcard:'',
        business_license:'',
      },
      reject_reason: '',
      status:'',
      /*左边长度*/
      formLabelWidth: '200px',
      /*是否显示*/
      dialogVisible: false
    };
  },
  props: ['open_edit', 'form'],
  created() {
    this.dialogVisible = this.open_edit;
    this.detail=this.form
    this.status = this.form.order_status;
    this.getCertification();
    console.log(this.status,this.detail)
    if (this.status == 20) {
      this.reject_reason = this.form.reject_reason;
    }
  },
  methods: {
    /*修改用户*/
    editApplyStatus() {
      let self = this;
       let params = this.form;
       console.log(params)
      PlusApi.editGradeOrderStatus(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，修改成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {});
    },
    /*获取实名认证信息*/
    getCertification() {
      let self = this;
      let user_id=self.detail.user_id;
      PlusApi.certifyDetail({user_id:user_id}, true)
        .then(data => {
          self.certification=data.data.detail
          
        })
        .catch(error => {});
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style>
.el-dialog__body{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/user/setting/part/Edit.vue